import {
    MeetingAcceptedIconText,
    MeetingCanceledIconText,
    MeetingDeclinedIconText,
    MeetingRequestIconText,
    MeetingTentativelyAcceptedIconText,
} from './getMeetingIcon.locstring.json';
import { ControlIcons } from 'owa-control-icons';
import { isCalendarRollUpEnabled } from 'owa-mail-reading-pane-store/lib/utils/rollUp/calendarRollUpUtils';
import {
    ACCEPTED_ITEM_CLASS,
    CANCELED_ITEM_CLASS,
    DECLINED_ITEM_CLASS,
    MEETING_REQUEST_ITEM_CLASS,
    TENTATIVE_ITEM_CLASS,
} from 'owa-mail-reading-pane-store/lib/utils/rollUp/calendarRollUpUtils';
import loc from 'owa-localize';

interface ItemClassIcon {
    itemClass: RegExp;
    icon: ControlIcons;
    ariaLabel: string;
}

export default function getMeetingIcon(itemClass: string): [ControlIcons, string] {
    if (!itemClass || !isCalendarRollUpEnabled()) {
        return [null, null];
    }

    const meetingIconMap: ItemClassIcon[] = [
        {
            itemClass: ACCEPTED_ITEM_CLASS,
            icon: ControlIcons.EventAccepted,
            ariaLabel: loc(MeetingAcceptedIconText),
        },
        {
            itemClass: TENTATIVE_ITEM_CLASS,
            icon: ControlIcons.EventTentative,
            ariaLabel: loc(MeetingTentativelyAcceptedIconText),
        },
        {
            itemClass: DECLINED_ITEM_CLASS,
            icon: ControlIcons.EventDeclined,
            ariaLabel: loc(MeetingDeclinedIconText),
        },
        {
            itemClass: CANCELED_ITEM_CLASS,
            icon: ControlIcons.RemoveEvent,
            ariaLabel: loc(MeetingCanceledIconText),
        },
        {
            itemClass: MEETING_REQUEST_ITEM_CLASS,
            icon: ControlIcons.Event,
            ariaLabel: loc(MeetingRequestIconText),
        },
    ];

    let icon: ItemClassIcon = null;
    meetingIconMap.some(meetingIcon => {
        if (itemClass.match(meetingIcon.itemClass)) {
            icon = meetingIcon;
            return true;
        }
        return false;
    });

    return icon ? [icon.icon, icon.ariaLabel] : [null, null];
}
